module.exports = __webpack_public_path__ + "static/media/2.14_preview.2e507545.png";